import { CommonUI } from "@src/common/CommonUI/CommonUI";
import { IllustrationBG } from "@src/common/IllustrationBG/IllustrationBG";
import { PageLayout } from "@src/common/PageLayout";
import { MEDIA_QUERIES } from "@src/constants/media-queries";
import { useMediaQuery } from "@uhg-abyss/web/hooks/useMediaQuery";
import { styled } from "@uhg-abyss/web/tools/styled";
import { ToastProvider } from "@uhg-abyss/web/ui/Toast";
import { Fragment, useEffect, useRef, useState } from "react";
import { GetStartedForm } from "./GetStartedForm";
import { GetStartedIntro } from "./GetStartedIntro";
import { NavButtons } from "./NavButtons";

const GetStartedContent = styled("div", {
  height: "auto !important",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "start",
  width: "100%",
});

const BACKGROUND_BOTTOM_PADDING = 80;

export const GetStarted = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [backgroundHeight, setBackgroundHeight] = useState(0);
  const isMobile = useMediaQuery(MEDIA_QUERIES.mobileMax);

  // Keep the blue background tall enough to contain the whole intro header.
  useEffect(() => {
    const content = contentRef.current;
    const topSection = content?.querySelector<HTMLElement>(
      '[data-testid="test-id-common-ui-top-section"]',
    );
    if (!content || !topSection || typeof ResizeObserver === "undefined") return;

    const update = () => {
      const bottom =
        topSection.getBoundingClientRect().bottom - content.getBoundingClientRect().top;
      setBackgroundHeight(Math.ceil(bottom + BACKGROUND_BOTTOM_PADDING));
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(topSection);
    return () => observer.disconnect();
  }, []);

  return (
    <Fragment>
      <ToastProvider />
      <PageLayout css={{ paddingBottom: isMobile ? "0" : "50px" }}>
        <IllustrationBG minHeight={backgroundHeight} />
        <GetStartedContent ref={contentRef} data-testid="test-id-get-started-content">
          <CommonUI
            metaTitle="Hope, help and healing start here"
            introContent={<GetStartedIntro />}
            FormComponent={GetStartedForm}
            topSectionMobileCss={{
              maxWidth: "100%",
              padding: "0 16px",
            }}
          />
          <div></div>
          <NavButtons isMobile={isMobile} />
        </GetStartedContent>
      </PageLayout>
    </Fragment>
  );
};
